module.exports = __webpack_public_path__ + "static/media/body-bg-3.5e029262.jpg";